<template>
  <div class="app-container">
    <div class="search-area">
      <el-form :inline="true" :model="query" @keyup.enter.native="loadData">
        <el-form-item label="排产日期">
          <el-date-picker
              v-model="query.planDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:160px"
              clearable/>
        </el-form-item>
        <el-form-item label="排产产线">
          <el-select
              v-model="query.productionLineId"
              style="width:140px"
              clearable
              placeholder="全部"
              @change="handleLineChange">
            <el-option
                v-for="item in lineList"
                :key="item.id"
                :label="item.lineName"
                :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="工序类型">
          <el-select v-model="query.productionLineType" clearable placeholder="全部" style="width:120px">
            <el-option label="组装" :value="1"/>
            <el-option label="测试" :value="2"/>
            <el-option label="发料" :value="3"/>
            <el-option label="包装" :value="4"/>
            <el-option label="发货前处理" :value="5"/>
            <el-option label="老化" :value="6"/>
          </el-select>
        </el-form-item>
        <el-form-item label="班次">
          <el-select v-model="query.shiftId" style="width:120px" clearable placeholder="请选择班次">
            <el-option
                v-for="item in shiftList"
                :key="item.id"
                :label="item.shiftName"
                :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadData">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-loading="loading" class="table-area">
      <div class="title">
        <i class="el-icon-s-data"/> 产线排产看板：{{currentLineName}} {{currentShiftName}} {{query.planDate}}
      </div>
      <!-- 色块图例 -->
      <div class="legend">
        <span class="legend-title">色块说明：</span>
        <span class="legend-item">
          <el-tag type="success" size="mini">已完工</el-tag>
          <span class="legend-desc">已完工数量 ≥ 工单数量</span>
        </span>
        <span class="legend-item">
          <el-tag type="warning" size="mini">生产中</el-tag>
          <span class="legend-desc">0 &lt; 已完工数量 &lt; 工单数量</span>
        </span>
        <span class="legend-item">
          <el-tag type="danger" size="mini">未开工</el-tag>
          <span class="legend-desc">已完工数量 = 0</span>
        </span>
        <span class="legend-item">
          <span style="color:red;font-weight:bold">红</span>
          <span class="legend-desc">历史日期未完工，顺延至当前班次继续生产</span>
        </span>
      </div>
      <view-table
          ref="viewTable"
          :columns-property="columnsProperty"
          :filter="query"
          module="basic"
          method="postJson"
          url="productionOrderScheduled/workshop"
          :column-width="130"
          :merge-columns="['productionLine','scheduledPerson','planDate','shift','processPersonNum']"
          @reset="resetHandle">
        <el-table-column type="index" label="序号" align="center" width="50"/>
        <el-table-column prop="productionOrderNo" label="生产订单号" align="center" width="150"/>
        <el-table-column
            prop="orderTypeName"
            label="工单类型"
            align="center"
            width="100"
            show-overflow-tooltip/>
        <el-table-column prop="productLayer" label="产品层次" align="center" width="90"/>
        <el-table-column prop="materialNo" label="物料编号" align="center" width="110"/>
        <el-table-column prop="materialDescription" label="物料名称" width="140" show-overflow-tooltip/>
        <el-table-column prop="workTime" label="工序工时(H)" align="center" width="100"/>
        <el-table-column prop="totalWorkTime" label="总工时(H)" align="center" width="90"/>
        <el-table-column prop="customerNo" label="客户" align="center" width="80"/>
        <el-table-column prop="addDate" label="下单日期" align="center" width="110"/>
        <el-table-column prop="productEnd" label="计划完工日期" align="center" width="120"/>
        <el-table-column prop="billTypeName" label="单据类别" align="center" width="90"/>
        <el-table-column prop="scheduledPerson" label="人员安排" min-width="150" show-overflow-tooltip/>
        <template slot="actionBtn" slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleManualComplete(scope.row)">手工结单</el-button>
        </template>
      </view-table>
    </div>
    <dispatch-detail ref="dispatchDetail"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import DispatchDetail from "@/views/ProductionManagement/ProductionOrder/DispatchDetail.vue";

  export default {
    name: "WorkshopScheduleList",
    components: {ViewTable, DispatchDetail},
    data() {
      return {
        loading: false,
        tableHeight: 600,
        query: {
          planDate: this.$moment().format("YYYY-MM-DD"),
          productionLine: "",
          productionLineId: null,
          productionLineType: 1,
          shiftId: null,
        },
        lineList: [],
        shiftList: [],
        tableData: [],
        scheduledPerson: "",
        personCount: 0,
        columnsProperty:[
          {
            key:"productionOrderNo",
            align:"center",
            width: 150,
            render: (h, params) => {
              const row = params.row;
              const isHistory = row.historyFlag === true;
              const orderNoSpan = h("span", {
                style: {color: "#2d8cf0", fontWeight: "bold", cursor: "pointer"},
                on: {click: () => this.$refs.dispatchDetail.openByNo(row.productionOrderNo)},
              }, row.productionOrderNo);
              if (isHistory) {
                return h("div", {}, [
                  orderNoSpan,
                  h("span", {style: {color: "red", fontWeight: "bold", marginLeft: "4px"}}, "历"),
                ]);
              }
              return orderNoSpan;
            },
          },
          {
            key: "orderNumber",
            align: "center",
            width: 90,
          },
          {
            key: "quantity",
            align: "center",
            width: 90,
          },
          {
            key: "completedQuantity",
            align: "center",
            width: 150,
            render: (h, params) => {
              const tagType = this.getCompletedTagType(params);
              const assembled = params.row.completedQuantity == null ? 0 : params.row.completedQuantity;
              // 只有组装工序（productionLineType === 1）才同时显示两道工序的完工数量
              const isAssemble = Number(params.row.productionLineType) === 1;
              let text;
              if (isAssemble) {
                // 无老化前测试工序时显示"无"，否则显示老化前测试数量
                const hasAgingTest = params.row.hasAgingTestProcess === true;
                const agingText = hasAgingTest
                  ? (params.row.agingTestQuantity == null ? 0 : params.row.agingTestQuantity)
                  : "无";
                text = assembled + "/" + agingText;
              } else {
                text = assembled;
              }
              return h("el-tag", {
                props: { type: tagType, size: "small", effect: "light" },
              }, text);
            },
          },
          {
            key: "produceWorkTime",
            title: "产出工时(H)",
            align: "center",
            width: 100,
            render: (h, params) => {
              const orderNum = Number(params.row.orderNumber) || 0;
              const completedNum = Number(params.row.completedQuantity) || 0;
              const workTime = Number(params.row.workTime) || 0;
              let produceWorkTime = 0;
              if (orderNum > 0) {
                produceWorkTime = (completedNum / orderNum) * workTime;
              }
              return h("span", {}, produceWorkTime.toFixed(2));
            },
          },
          {
            key: "action",
            align: "center",
            width: 100,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    computed: {
      currentShiftName() {
        const item = this.shiftList.find(s => s.id === this.query.shiftId);
        return item ? item.shiftName : "";
      },
      currentLineName() {
        const item = this.lineList.find(l => l.id === this.query.productionLineId);
        return item ? item.lineName : "";
      },
    },

    mounted() {
      this.calcTableHeight();
      window.addEventListener("resize", this.calcTableHeight);
      this.loadLineList();
      this.loadShiftList();
    },

    beforeDestroy() {
      window.removeEventListener("resize", this.calcTableHeight);
    },

    methods: {
      // 加载产线下拉列表（从 MES_ProductionLine 取值）
      loadLineList() {
        this.$http.get("basic", "fm/production-mangeline/list").then(res => {
          if (res.success) {
            this.lineList = res.data || [];
          }
        });
      },
      // 加载班次模板下拉列表（从 MES_CalendarShift 取值）
      loadShiftList() {
        this.$http.get("basic", "fm/calendarShift/list").then(res => {
          if (res.success) {
            this.shiftList = res.data || [];
            // 默认选中第一个"白班"类型的班次（shiftType=1）
            const first = this.shiftList.find(s => s.shiftType === 1) || this.shiftList[0];
            if (first && this.query.shiftId == null) {
              this.query.shiftId = first.id;
            }
            this.loadData();
          }
        });
      },
      // 根据工单数量和已完工数量返回 el-tag 类型（用于"已完工数量"列）
      // 组装工序：含老化前测试工序时，组装数与老化前测试数都 >= 工单数量才算已完工；
      //           无老化前测试工序时，只看组装数量
      // 其他工序：只看当前工序已完工数量
      getCompletedTagType(params) {
        const orderNum = Number(params.row.orderNumber) || 0;
        const completedNum = Number(params.row.completedQuantity) || 0;
        const agingTestNum = Number(params.row.agingTestQuantity) || 0;
        const hasAgingTest = params.row.hasAgingTestProcess === true;
        const isAssemble = Number(params.row.productionLineType) === 1;
        if (orderNum <= 0) return "";
        if (isAssemble && hasAgingTest) {
          if (completedNum >= orderNum && agingTestNum >= orderNum) return "success"; // 已完工
          if (completedNum > 0 || agingTestNum > 0) return "warning";                 // 生产中
        } else {
          if (completedNum >= orderNum) return "success";                              // 已完工
          if (completedNum > 0) return "warning";                                      // 生产中
        }
        return "danger";                                        // 未开工
      },
      calcTableHeight() {
        this.tableHeight = (window.innerHeight || document.documentElement.clientHeight) - 200;
      },

      loadData() {
        this.$refs.viewTable.loadData();
      },

      resetQuery() {
        this.query = {
          planDate: this.$moment().format("YYYY-MM-DD"),
          productionLine: "",
          productionLineId: null,
          productionLineType: null,
          shiftId: null,
        };
        this.loadData();
      },

      // 手工结单：将该条排产记录强制标记为已完工，落库后刷新看板
      handleManualComplete(row) {
        if (!row || row.pkId == null) {
          this.$message.warning("缺少排产记录ID");
          return;
        }
        this.$confirm(`确认将工单 ${row.productionOrderNo}（${row.planDate}）手工结单？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$http.post("basic", "productionOrderScheduled/manualComplete", null, {pkId: row.pkId}).then(res => {
            if (res.success) {
              this.$message.success("手工结单成功");
              this.loadData();
            } else {
              this.$message.error(res.message || "手工结单失败");
            }
          });
        }).catch(() => {});
      },

      // 切换产线：根据选中产线的工序类型联动设置，同时保留 productionLine 枚举名
      handleLineChange(val) {
        const line = this.lineList.find(l => l.id === val);
        if (line) {
          this.query.productionLine = line.lineName;
          if (line.lineType != null) {
            this.query.productionLineType = Number(line.lineType);
          }
        } else {
          this.query.productionLine = "";
        }
        this.loadData();
      },

      resetHandle(filter) {
        const approveType = this.query.approveType;
        this.query = Object.assign(this.query, filter);
        this.query.approveType = approveType;
      },
    },
  };
</script>

<style scoped lang="scss">
.app-container {
  padding: 15px;
}
.search-area {
  margin-bottom: 10px;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #303133;
  i {
    margin-right: 6px;
  }
}
.legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  padding: 6px 10px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  .legend-title {
    font-weight: bold;
    color: #303133;
    margin-right: 12px;
  }
  .legend-item {
    display: inline-flex;
    align-items: center;
    margin-right: 16px;
  }
  .legend-desc {
    margin-left: 4px;
    color: #606266;
  }
}
::v-deep .el-table__footer {
  .cell { font-weight: bold; }
}
.line-info-cell {
  line-height: 1.8;
  font-size: 13px;
}
.person-names {
  white-space: normal;
  word-break: break-all;
}
</style>
